// media_download 表的字段
const MEDIA_DOWNLOAD_TABLE_FIELDS = [
  'id',
  'name',
  'gbId',
  'path',
  'speed',
  'devId',
  'endTime',
  'startTime',
  'fileEncrypt',
  'state',
  'user',
  'fullInfo'
];

class MediaSql {
  constructor() {
    this.db = '';
  }

  /**
   * @description: 执行至最大尝试次数或成功为止
   * @param {Number} opt.checkSpan 重试间隔(毫秒)
   * @param {Number} opt.maxTryCount 最大尝试次数(不设置，尝试到成功为止)
   * @return:
   */

  waitUntil(fn, opt = {}) {
    return new Promise((resolve, reject) => {
      const checkSpan = opt.checkSpan || 1000;
      const needCount = opt.maxTryCount !== undefined;
      opt.done = false;
      const execute = () => fn(opt);
      execute();
      const checkDone = setInterval(() => {
        if (needCount && !opt.done) {
          opt.maxTryCount--;
          if (opt.maxTryCount <= 0) {
            clearInterval(checkDone);
            reject('超过最大重试次数');
            return;
          }
        }
        if (opt.done) {
          clearInterval(checkDone);
          resolve(opt.res);
          return;
        }
        execute();
      }, checkSpan);
      opt.resolve = (dat) => {
        clearInterval(checkDone);
        resolve(dat);
      };
      opt.reject = (dat) => {
        clearInterval(checkDone);
        reject(dat);
      };
    });
  }

  init() {
    // 数据库并发open会报错 此处
    return this.waitUntil(
      (opt) => {
        try {
          this.db = window.openDatabase(
            'kiaf_media_history',
            '1.0',
            null,
            20000
          );
          this.db.transaction(function(tr) {
            tr.executeSql(
              'CREATE TABLE IF  NOT EXISTS media_download (id INTEGER PRIMARY KEY, ' +
                'name text,' +
                'gbId text,' +
                'path text,' +
                'speed text,' +
                'devId text,' +
                'endTime text,' +
                'startTime text,' +
                'fileEncrypt text,' +
                'state text,' +
                'user text,' +
                'fullInfo text)' // fullInfo 用来保存全部信息，将 message 序列化之后存入
            );
          });
          opt.done = true;
        } catch (error) {
          console.log('openDatabase media_sql1 >>', error);
        }
      },
      { maxTryCount: 10 }
    );
  }

  add(params) {
    console.log(`media-sql add ----------- `, params);
    let sql = '';
    let keys = [];
    let vals = [];

    // 将表格要求的字段提取出来
    for (const key of MEDIA_DOWNLOAD_TABLE_FIELDS) {
      if (key === 'fullInfo') {
        // 保存完整信息
        keys.push(`"${key}"`);
        vals.push(`'${JSON.stringify(params)}'`);
      } else {
        keys.push(`"${key}"`);
        vals.push(`"${params[key]}"`);
      }
    }

    sql = `insert into media_download (${keys.join(',')}) values (${vals.join(',')})`;
    console.log(sql);
    return new Promise((resolve, reject) => {
      this.db.transaction(function(tr) {
        tr.executeSql(sql);
        resolve('已添加一个视频下载任务！');
      });
    });
  }

  findByState(state) {
    // 0为正在下载  1为已经下载
    let sql = '';
    if (state === undefined) {
      sql = 'select * from media_download';
    } else {
      sql = `select * from media_download where state = ${state}`;
    }

    console.log(sql);
    return this.waitUntil(
      (opt) => {
        this.db.transaction(function(tr) {
          tr.executeSql(
            sql,
            [],
            (ctx, res) => {
              opt.done = true;
              // 处理数据
              console.log(
                `media-sql - findByState - rows 原始数据 = `,
                res.rows
              );
              let list = [];
              for (let i = 0, len = res.rows.length; i < len; i++) {
                let item = res.rows[i];
                list.push(item);
              }

              list.forEach((item) => {
                if (typeof item.fullInfo !== 'undefined') {
                  // 获取全部信息
                  let fullInfo = JSON.parse(item.fullInfo);

                  // 补全 item 中缺失的字段
                  for (const key in fullInfo) {
                    if (!item.hasOwnProperty(key)) {
                      item[key] = fullInfo[key];
                    }
                  }

                  // 删除多余的 fullInfo 字段
                  delete item.fullInfo;
                }
              });

              console.log(`media-sql - findByState - rows 处理数据 = `, list);
              // opt.res = res;
              opt.res = {
                rows: list
              };
              console.log('buffer2');
            },
            (ctx, res) => {
              opt.reject('查询失败');
            }
          );
        });
      },
      { maxTryCount: 10 }
    );
  }

  deleteById(id) {
    let sql = `delete from media_download where id = ${id}`;
    return new Promise((resolve, reject) => {
      this.db.transaction(function(tr) {
        tr.executeSql(
          sql,
          [],
          (ctx, res) => {
            resolve('删除成功！');
          },
          (ctx, res) => {
            reject('删除失败');
          }
        );
      });
    });
  }

  updateState(id) {
    let sql = `update media_downLoad set state = "1" where id = ${id}`;
    this.db.transaction(function(tr) {
      tr.executeSql(sql);
    });
  }
}

export default MediaSql;
